import { OPTIONAL_STRING, REQUIRED_STRING, YEAR } from '@/components/Form/schema';
import { uniqueNameShortField } from '@/forms/forms';
import { GetScenarioByNameShortDocument, GetScenarioGroupByNameShortDocument } from '@/generated/graphql';
import { z } from 'zod';

const SCENARIO_GROUP_NAME_SHORT_FIELD = uniqueNameShortField(GetScenarioGroupByNameShortDocument);
const SCENARIO_NAME_SHORT_FIELD = uniqueNameShortField(GetScenarioByNameShortDocument);

export const ScenarioGroupCreateSchema = z.object({
    nameShort: SCENARIO_GROUP_NAME_SHORT_FIELD,
    nameLong: REQUIRED_STRING,
});
export type ScenarioGroupCreateSchemaType = z.infer<typeof ScenarioGroupCreateSchema>;

export const ScenarioCreateSchema = z.object({
    nameShort: SCENARIO_NAME_SHORT_FIELD,
    nameLong: REQUIRED_STRING,
    year: YEAR,
});
export type ScenarioCreateSchemaType = z.infer<typeof ScenarioCreateSchema>;

export function getScenarioGroupSchema(scenarioGroupId: string) {
    return z.object({
        nameShort: uniqueNameShortField(GetScenarioGroupByNameShortDocument, scenarioGroupId),
        nameLong: REQUIRED_STRING,
        intention: OPTIONAL_STRING,
        description: OPTIONAL_STRING,
        kapmanNumber: OPTIONAL_STRING,
        companyGroup: OPTIONAL_STRING,
        businessDomain: OPTIONAL_STRING,
        department: OPTIONAL_STRING,
        responsible: OPTIONAL_STRING,
    });
}

export function getScenarioSchema(scenarioId: string) {
    return z.object({
        nameShort: uniqueNameShortField(GetScenarioByNameShortDocument, scenarioId),
        nameLong: REQUIRED_STRING,
        year: YEAR,
        intention: OPTIONAL_STRING,
        description: OPTIONAL_STRING,
    });
}
